import psPlatformClient from "../psPlatformClient";
import {AdminConfigurableUserData} from "../ps-models";

export const getUsers = async (): Promise<AdminConfigurableUserData[]> => {
  const result = await psPlatformClient<null, any[]>({ method: 'get', url: '/users' })
  return result.data;
}